module.exports = __webpack_public_path__ + "img/NPC-frontSmall.25e23bdb.jpg";